export default __webpack_public_path__ + "static/media/0005.01759e8d.jpg";